import { render } from "./AppAside.vue?vue&type=template&id=2cc115ee&scoped=true"
import script from "./AppAside.vue?vue&type=script&lang=js"
export * from "./AppAside.vue?vue&type=script&lang=js"

import "./AppAside.vue?vue&type=style&index=0&id=2cc115ee&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2cc115ee"]])

export default __exports__